import { Component } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-editcarcounterconfiguration',
    templateUrl: './editcarcounterconfiguration.component.html',
    styleUrls: ['./editcarcounterconfiguration.component.scss'],
    standalone: false
})

export class EditCarCounterConfiguration extends SimpleModalComponent<any, null>{
  Form !: UntypedFormGroup;

  public InitialGateway: any = {};

  constructor() {
    super();
  }

  confirm() {
    let formthing = this.Form.controls["ChipId"];
    this.close();
  }
}
